import React, { useEffect, useState } from "react"
import { Card, CardBody, Col, Container, Row } from "reactstrap"
import StatsCard from "../../components/StatsCard"
import "react-loading-skeleton/dist/skeleton.css"
import TotalSales from "components/TotalSales"
import OrderStatus from "components/OrderStatus"
import { BiPurchaseTagAlt } from "react-icons/bi"
import { AiOutlineShopping } from "react-icons/ai"
import { TbShoppingCartCancel } from "react-icons/tb"
import {
  getRejectedOrderCount,
  getTotalInquiryCount,
  getTotalOrderCount,
  getTotalPurchase,
} from "http/dashboard"
import { formatNumberWithCommas } from "common/utility"
import { BsPatchQuestion } from "react-icons/bs"
import { getCreditLimit, getLedgerReport, getTargetList, getActualSale } from "helpers/UAM/report.helper"
import moment from 'moment';
import TargetIcon from '../../assets/images/image 2417 (traced).svg'
import ActualSaleIcon from '../../assets/images/image 2418 (traced).svg'
import CreditLimitIcon from '../../assets/images/image 2419 (traced).svg'
import OverdueIcon from '../../assets/images/image 2420 (traced).svg'
import OutstandingIcon from '../../assets/images/outstanding.svg'



const DealerDashboard = () => {
  document.title = "Dashboard | Subros"
  const [dashboardItem, setDashboardItem] = useState({})
  const [creditInfo, setCreditInfo] = useState({})
  const [targetInfo, setTargetInfo] = useState(0)
  const [actualSale, setActualSale] = useState(0)
  const [overdueAmount, setOverdueAmount] = useState(0)
  const [outstandingAmount, setOutstandingAmount] = useState(0)


  const getData = async () => {
    let result = {}

    let { data: totalOrder } = await getTotalOrderCount()
    result.totalOrder = totalOrder

    let { data: rejectedOrder } = await getRejectedOrderCount()
    result.rejectedOrder = rejectedOrder

    let { data: totalAmount } = await getTotalPurchase()
    result.totalAmount = formatNumberWithCommas(+totalAmount)

    let { data: inquiry } = await getTotalInquiryCount()
    result.inquiry = inquiry

    let { data: credit } = await getCreditLimit()
    if (credit?.STATUS == 'SUCCESS') {
      setCreditInfo(credit)
    } else {
      setCreditInfo({})
    }

    let data = await getActualSale()
    if (data.status && data?.data[0]?.totalActualSale) {
      setActualSale(data?.data[0]?.totalActualSale)
    }
    
    let targerData = await getTargetList({ filters: { endDate: moment().format('YYYY-MM'), startDate: moment().format('YYYY-MM') } })
    if (targerData.status && targerData?.data?.data) {
      setTargetInfo(targerData?.data?.data[0].target)
    }

    let ledgerData = await getLedgerReport({"openItem":true,"closeItem":false,"allItem":false})
    if (ledgerData.status && ledgerData?.data?.length > 0) {
      const totalAmountInLC = ledgerData?.data?.reduce((sum, report) => sum + (report.AMOUNT_IN_LC || 0), 0);
      setOutstandingAmount(totalAmountInLC)

      const todayDate = new Date().toISOString().slice(0, 10).replace(/-/g, "");
      const totalOverdueAmountInLC = ledgerData?.data?.reduce((sum, report) => {
        return report.NET_DUE_DATE < todayDate ? sum + (report.AMOUNT_IN_LC || 0) : sum;
      }, 0);
      setOverdueAmount(totalOverdueAmountInLC)
    }
    setDashboardItem(result)
  }

  useEffect(() => {
    getData()
  }, [])

  const adminNumberData = [
    {
      id: 1,
      label: "Total purchase",
      value: dashboardItem.totalAmount,
      color: "info",
      icon: (
        <BiPurchaseTagAlt
          className={`me-3 text-info`}
          style={{ fontSize: "24px" }}
        />
      ),
      url: "/customer/orders",
    },
    {
      id: 2,
      label: "New Product Inquiries",
      value: dashboardItem.inquiry,
      color: "success",
      icon: (
        <BsPatchQuestion
          className={`me-3 text-success`}
          style={{ fontSize: "24px" }}
        />
      ),
      url: "/customer/product-inquiry",
    },
    {
      id: 3,
      label: "Total Requested Orders",
      value: dashboardItem.totalOrder,
      color: "warning",
      icon: (
        <AiOutlineShopping
          className={`me-3 text-warning`}
          style={{ fontSize: "24px" }}
        />
      ),
      url: "/customer/order-request",
    },
    {
      id: 4,
      label: "Rejected Orders",
      value: dashboardItem.rejectedOrder,
      color: "danger",
      icon: (
        <TbShoppingCartCancel
          className={`me-3 text-danger`}
          style={{ fontSize: "24px" }}
        />
      ),
      url: "/customer/order-request?tab=5",
    },
  ]

  return (
    <div>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col className="col-12">
              <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4
                
                  className="mb-sm-0 font-size-18" style={{marginLeft:'0.7rem'}}
                >
                  Dashboard
                </h4>
              </div>
            </Col>
          </Row>
          <div className="vertical-scroll">
            <Row className="custom-row m-0">
              <Col lg='12' className="mb-3">
                <Card style={{ backgroundImage: 'linear-gradient(269deg, rgba(60, 119, 236, 0.51) 0%, rgba(255, 255, 255, 0.5) 58%)' }}>
                  <CardBody>
                    <div className="text-end">{moment().format('MMMM, YYYY')}</div>
                    <div className="d-md-flex justify-content-between" >
                      <div className="p-2" style={{ width: '100%' }}>
                        <h5>Target
                          <img
                            src={TargetIcon}
                            alt="Target Icon"
                            style={{ marginLeft: '8px', verticalAlign: 'middle', width: '24px', height: '24px' }}
                          />
                        </h5>
                        <div style={{ borderBottom: '1px solid #BFBFC5' }} className='mb-3 mt-3'></div>
                        <div className='font-size-18' style={{ fontWeight: '600', color: '#666666' }}>{formatNumberWithCommas(targetInfo) || 0}</div>
                      </div>
                      <div className="p-2" style={{ width: '100%' }}>
                        <h5>Actual Sale
                          <img
                            src={ActualSaleIcon}
                            alt="Target Icon"
                            style={{ marginLeft: '8px', verticalAlign: 'middle', width: '24px', height: '24px' }}
                          />
                        </h5>
                        <div style={{ borderBottom: '1px solid #BFBFC5' }} className='mb-3 mt-3'></div>
                        <div className='font-size-18' style={{ fontWeight: '600', color: '#666666' }}>{formatNumberWithCommas(actualSale) || 0}</div>
                      </div>
                      <div className="p-2" style={{ width: '100%' }}>
                        <h5>Available credit limit
                          <img
                            src={CreditLimitIcon}
                            alt="Target Icon"
                            style={{ marginLeft: '8px', verticalAlign: 'middle', width: '24px', height: '24px' }}
                          />
                        </h5>
                        <div style={{ borderBottom: '1px solid #BFBFC5' }} className='mb-3 mt-3'></div>
                        <div className='font-size-18' style={{ fontWeight: '600', color: '#666666' }}>{formatNumberWithCommas(creditInfo?.AVAILABLE_LIMIT || 0)}</div>
                      </div>
                      <div className="p-2" style={{ width: '100%' }}>
                        <h5>Outstanding
                          <img
                            src={OutstandingIcon}
                            alt="Target Icon"
                            style={{ marginLeft: '8px', verticalAlign: 'middle', width: '24px', height: '24px' }}
                          />
                        </h5>
                        <div style={{ borderBottom: '1px solid #BFBFC5' }} className='mb-3 mt-3'></div>
                        <div className='font-size-18' style={{ fontWeight: '600', color: '#666666' }}>{formatNumberWithCommas(outstandingAmount)}</div>
                      </div>
                      <div className="p-2" style={{ width: '100%' }}>
                        <h5>Overdue
                          <img
                            src={OverdueIcon}
                            alt="Target Icon"
                            style={{ marginLeft: '8px', verticalAlign: 'middle', width: '24px', height: '24px' }}
                          />
                        </h5>
                        <div style={{ borderBottom: '1px solid #BFBFC5' }} className='mb-3 mt-3'></div>
                        <div className='font-size-18' style={{ fontWeight: '600', color: '#666666' }}>{formatNumberWithCommas(overdueAmount)}</div>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
              {adminNumberData?.map(i => (
                <Col  key={i.id} md={6} lg={3} className="p-0 " >
                  <StatsCard
                    color={i.color}
                    label={i?.label}
                    value={i?.value}
                    url={i?.url}
                    icon={i?.icon}
                  />
                </Col>
              ))}
            </Row>
            <Row style={{ marginBottom: "1rem" }} className="ms-1 me-1 mt-2  g-3">
            <Col lg={6}>
              <TotalSales userType={"dealer"} />
            </Col>
            <Col lg={6}>
              <OrderStatus
                totalOrders={dashboardItem.totalOrder || 0}
                userType={'admin'}
                dataColors='["#EC7063", "#AF7AC5", "#3498DB ","#1ABC9C", "#F1C40F"]'
              />
            </Col>
          </Row>
          </div>
          
        </Container>
      </div>
    </div>
  )
}

const adminNumberData = [
  {
    id: 1,
    label: "Total purchase",
    value: 55,
    color: "info",
    icon: (
      <BiPurchaseTagAlt
        className={`me-3 text-info`}
        style={{ fontSize: "24px" }}
      />
    ),
  },
  {
    id: 2,
    label: "Total Orders",
    value: 33,
    color: "warning",
    icon: (
      <AiOutlineShopping
        className={`me-3 text-warning`}
        style={{ fontSize: "24px" }}
      />
    ),
    url: "/admin/orders",
  },
  {
    id: 3,
    label: "Rejected",
    value: 300,
    color: "danger",
    icon: (
      <TbShoppingCartCancel
        className={`me-3 text-danger`}
        style={{ fontSize: "24px" }}
      />
    ),
  },
]

export default DealerDashboard
